<template>
  <div style="padding-top: 40px">
    <div class="bottomCom">
      <div class="mainBody">
        <div>
          <img src="../assets/publicImg/logo.svg" alt="" style="height: 18px; padding: 20px" />
        </div>
        <div class="content">
          <div class="content1">
            <div class="contentTitle">首页</div>
            <!-- <div><span @click="scrollToSection('company-intro')">公司简介</span></div> -->
            <!-- <div><span @click="scrollToSection('team-intro')">团队介绍</span></div> -->
            <div><span @click="scrollToSection('solutions')">产品序列</span></div>
            <div><span @click="scrollToSection('service-clients')">服务客户</span></div>
            <div><span @click="scrollToSection('news')">最新资讯</span></div>
            <div><span @click="scrollToSection('contact')">联系我们</span></div>
          </div>
          <div class="content1">
            <div class="contentTitle">关于研视</div>
            <div>
              <span @click="scrollToAboutSection('company-intro')">公司简介</span>
            </div>
            <div>
              <!-- <span @click="$router.push('history')">研视大事记</span> -->
              <span @click="scrollToAboutSection('history')">研视大事记</span>
              <!-- <span @click="$router.push('/aboutYells/history')">研视大事记</span> -->
            </div>
            <div>
              <span @click="scrollToAboutSection('honor')">重要荣誉</span>
            </div>
            <div>
              <span @click="scrollToAboutSection('partners')">合作伙伴</span>
            </div>
            <div>
              <span @click="scrollToAboutSection('sales-area')">销售大区</span>
            </div>
            <div>
              <span @click="scrollToAboutSection('online-message')">在线留言</span>
            </div>
            <div>
              <span @click="scrollToAboutSection('cooperation')">合作承诺</span>
            </div>
          </div>
          <div class="content1">
            <div class="contentTitle">解决方案</div>
            <div><span @click="toAtomMap()">能力地图</span></div>
            <div>
              <span @click="scrollToSolutionSection('products')">产品与服务</span>
            </div>
            <!-- <div>
              <span @click="$router.push('/solution')">研视类品</span>
            </div> -->
          </div>
          <div class="content1">
            <div class="contentTitle">资讯</div>
            <div>
              <span @click="$router.push('/information/' + 1)">研视动态</span>
            </div>
            <div>
              <span @click="$router.push('/information/' + 1)">热点推荐</span>
            </div>
          </div>
          <div class="content1">
            <div class="contentTitle">加入我们</div>
            <div><span @click="$router.push('/recruit')">招聘</span></div>
            <div><span @click="scrollToRecruitSection('work-life')">工作在研视</span></div>
          </div>
          <div class="content2">
            <div class="contentTitle">联系我们</div>
            <div>021-36509952</div>
            <!-- <div>手机：18616124308</div>
            <div>dlhm@yells.com.cn</div> -->
            <div>总部：{{ contactAddresses[0] }}</div>
            <div>子公司：{{ contactAddresses[1] }}</div>
            <div>子公司：{{ contactAddresses[2] }}</div>
            <div>分公司：{{ contactAddresses[3] }}</div>
            <!-- <div class="weixinIcon">
              <img src="../assets/publicImg/weixin.svg" alt="" />
              <p>上海研视信息科技有限公司</p>
            </div>
            <div class="weixinIcon">
              <img src="../assets/publicImg/weixin.svg" alt="" />
              <p>研视AI钢铁</p>
            </div> -->
            <div class="erweima">
              <img src="../assets/publicImg/erweima1.png" alt="" />
              <img src="../assets/publicImg/erweima2.png" alt="" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="bottom">
      <div class="bottomContent">
        <div class="copyright-container">
          <div class="copyright-text">©2023 上海研视信息科技有限公司</div>
          <div class="beian-container">
            <img src="../assets/homePageImg/Plog.png" alt="" class="beian-icon" />
            <a href="https://beian.miit.gov.cn/" target="_blank" class="beian-link">沪ICP备20017727号</a>
            <span class="separator">|</span>
            <a href="https://beian.mps.gov.cn/#/query/webSearch?code=31011302007887" rel="noreferrer" target="_blank"
              class="beian-link">沪公网安备31011302007887</a>
          </div>
        </div>
      </div>
    </div>
    <!-- <transition name="el-fade-in-linear">
      <div
        v-show="isShowGoTopButton"
        class="transition-box goHeader"
        @click="goTop"
      >
        <div class="icon"></div>
        <p>回到顶部</p>
      </div>
    </transition> -->
  </div>
</template>
<script>
import { mapState } from "vuex";
import { getContactUs } from "../api/about.js";
export default {
  name: "bottomCom",
  data() {
    return {
      isShowGoTopButton: false,
      contactAddresses: ["", "", "", ""],
    };
  },
  computed: {
    ...mapState(["METAVERSE_URL"]),
  },
  methods: {
    toAtomMap() {
      window.open(this.METAVERSE_URL, "_blank");
    },
    handleScroll() {
      this.isShowGoTopButton = window.pageYOffset > 200;
    },
    goTop() {
      window.scrollTo({
        // 滚动到顶部
        top: 0,
        behavior: "smooth",
      });
    },
    toHome() {
      window.location.href = "/";
    },
    // 滚动到首页对应位置
    scrollToSection(section) {
      // 如果不在首页，先跳转到首页
      if (this.$route.path !== '/') {
        this.$router.push('/').then(() => {
          this.$nextTick(() => {
            this.scrollToElement(section);
          });
        });
      } else {
        this.scrollToElement(section);
      }
    },
    // 滚动到关于研视页面对应位置
    scrollToAboutSection(section) {
      // 跳转到关于研视页面并滚动到对应位置
      this.$router.push('/aboutYells').then(() => {
        this.$nextTick(() => {
          this.scrollToAboutElement(section);
        });
      });
    },
    // 滚动到解决方案页面对应位置
    scrollToSolutionSection(section) {
      // 跳转到解决方案页面并滚动到对应位置
      this.$router.push('/solution').then(() => {
        this.$nextTick(() => {
          this.scrollToSolutionElement(section);
        });
      });
    },
    // 滚动到招聘页面对应位置
    scrollToRecruitSection(section) {
      // 跳转到招聘页面并滚动到对应位置
      this.$router.push('/recruit').then(() => {
        this.$nextTick(() => {
          this.scrollToRecruitElement(section);
        });
      });
    },
    // 滚动到指定元素
    scrollToElement(section) {
      setTimeout(() => {
        let scrollTop = 0;
        switch(section) {
          case 'company-intro':
            scrollTop = 506; // 我们是谁部分
            break;
          case 'team-intro':
            scrollTop = 1300; //行业优势部分
            break;
          case 'solutions':
            scrollTop = 950; // 解决方案部分
            break;
          case 'service-clients':
            scrollTop = 1450; // 服务客户部分
            break;
          case 'news':
            scrollTop = 2000; // 新闻资讯部分
            break;
          case 'contact':
            scrollTop = 2500; // 联系我们部分
            break;
          default:
            scrollTop = 0;
        }
        window.scrollTo({
          top: scrollTop,
          behavior: "smooth",
        });
      }, 100);
    },
    // 滚动到关于研视页面指定位置
    scrollToAboutElement(section) {
      setTimeout(() => {
        let targetElement = null;
        let elementId = '';
        
        // 根据section映射到对应的元素ID
        switch(section) {
          case 'company-intro':
            elementId = 'company-intro-section';
            break;
          case 'history':
            elementId = 'history-section';
            break;
          case 'honor':
            elementId = 'honor-section';
            break;
          case 'partners':
            elementId = 'partners-section';
            break;
          case 'online-message':
            elementId = 'online-message-section';
            break;
          case 'cooperation':
            elementId = 'cooperation-section';
            break;
          case 'sales-area':
            elementId = 'online-message-section';
            break;
          default:
            // 默认滚动到页面顶部
            window.scrollTo({
              top: 0,
              behavior: "smooth",
            });
            return;
        }
        
        // 查找目标元素
        targetElement = document.getElementById(elementId);
        
        if (targetElement) {
          // 计算目标位置，减去50px偏移量以获得更好的视觉效果
          const offsetTop = targetElement.offsetTop - 50;
          window.scrollTo({
            top: offsetTop,
            behavior: "smooth",
          });
          console.log(`跳转到${section}区域，元素ID: ${elementId}`);
        } else {
          console.warn(`未找到元素ID: ${elementId}，使用备用滚动方案`);
          // 备用方案：滚动到页面顶部
          window.scrollTo({
            top: 0,
            behavior: "smooth",
          });
        }
      }, 100);
    },
    // 滚动到解决方案页面指定位置
    scrollToSolutionElement(section) {
      setTimeout(() => {
        let scrollTop = 0;
        switch(section) {
          case 'products':
            scrollTop = 666; // 慧眼系列部分
            break;
          default:
            scrollTop = 0;
        }
        window.scrollTo({
          top: scrollTop,
          behavior: "smooth",
        });
      }, 100);
    },
    // 滚动到招聘页面指定位置
    scrollToRecruitElement(section) {
      setTimeout(() => {
        let scrollTop = 0;
        switch(section) {
          case 'work-life':
            scrollTop = 800; // 工作在研视部分
            break;
          default:
            scrollTop = 0;
        }
        window.scrollTo({
          top: scrollTop,
          behavior: "smooth",
        });
      }, 100);
    },
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
    getContactUs().then((res) => {
      if (res && res.Code === 200 && Array.isArray(res.Data)) {
        const list = res.Data;
        this.contactAddresses = [0, 1, 2, 3].map((i) => (list[i] && list[i].Address) ? list[i].Address : "");
      }
    }).catch(() => {});
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
  },
};
</script>

<style scoped lang="scss">
.bottomCom,
.bottom {
  width: 100vw;
  display: flex;
  justify-content: center;
}
.mainBody,
.bottomContent {
  width: 1320px;
  display: flex;
  justify-content: space-between;
}
.mainBody {
  width: 1400px;
}
.bottomContent {
  width: 1320px;
  justify-content: center;
}
.content {
  width: 1155px;
  padding: 10px 0;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  .content1,
  .content2 {
    div {
      padding: 4px 14px;
      color: #596773;
      font-family: "Noto Sans SC Variables", sans-serif;
      font-size: 12px;
      font-style: normal;
      font-weight: 300;
      line-height: 24px;
      text-align: center;
    }
    .contentTitle {
      padding: 10px;
      color: #2c333a;
      font-size: 16px;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
      text-align: center;
    }
  }
  .content1 {
    width: 130px;
    flex-shrink: 0;
    span {
      cursor: pointer;
      &:hover {
        color: #b3b9c4;
      }
    }
  }
  
  .content2 {
    div {
      text-align: left !important; /* 联系我们区域内容左对齐 */
    }
  }
}
.weixinIcon {
  display: flex;
  p {
    padding-left: 14px;
  }
}
.erweima {
  height: 60px;
  margin-left: 10px;
  img {
    height: 60px;
    margin-right: 10px;
  }
}
.bottomContent {
  height: 56px;
  padding-top: 20px;
  margin: 20px 5px 0;
  border-top: 1px solid #dcdfe4;
  
  .copyright-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 8px;
    
    .copyright-text {
      color: #dcdfe4;
      font-family: "Noto Sans SC Variables", sans-serif;
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: 25px;
    }
    
    .beian-container {
      display: flex;
      align-items: center;
      gap: 6px;
      
      .beian-icon {
        width: 16px;
        height: 16px;
      }
      
      .beian-link {
        color: #596773;
        font-family: "Noto Sans SC Variables", sans-serif;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 25px;
        text-decoration: none;
        
        &:hover {
          color: #b3b9c4;
        }
      }
      
      .separator {
        color: #dcdfe4;
        font-family: "Noto Sans SC Variables", sans-serif;
        font-size: 14px;
        margin: 0 4px;
      }
    }
  }
}
.goHeader {
  width: 36px;
  height: 36px;
  position: fixed;
  bottom: 40px;
  /*right: 88px;*/
  left: calc(100vw - 124px);
  z-index: 99;
  background-color: #f1f2f4;
  cursor: pointer;
  border-radius: 4px;
  overflow: hidden;
  transition: width 0.2s linear;
  /*box-shadow: 0 0 8px 0 rgba(9, 30, 66, 0.1);*/
  .icon {
    position: absolute;
    top: 12px;
    left: 12px;
    width: 12px;
    height: 12px;
    transition: background 0.2s linear;
    background: url("../assets/publicImg/goTop.svg") center/cover;
  }
  p {
    position: absolute;
    left: 46px;
    width: 56px;
    font-size: 14px;
    line-height: 36px;
    font-weight: 400;
    font-family: "Noto Sans SC Variables", sans-serif;
    color: white;
  }
  &:hover {
    width: 112px;
    background-color: rgba(9, 30, 66, 0.3);
    .icon {
      background: url("../assets/publicImg/goTopHover.svg") center/cover;
    }
  }
}


</style>

